export enum Report {
  FILE = "file",
  USER = "user",
}